export const formatRequestType = (text: string) => {
  switch (text) {
    case 'vacation':
      return 'Vacaciones'
    case 'license':
      return `Licencia`
    default:
      return text
  }
}
